import { Button, Icon, Popover, Position } from "@blueprintjs/core"
import { Fragment, useState } from "react"
import { Outlet, useLocation, useParams } from "react-router"
import { Link } from "react-router-dom"
import { __ } from "src/libs/utilities"
import { component_url } from "src/libs/utilities/links"
import { useDataStore } from "src/modules/pe-basic-module/data/store"
import { IUser } from "src/settings/zustand"
import { ITestsStore, useTestsStore } from "../../data/store"
import useTest from "../../hooks/useTest"

/* Protopia Ecosystem component */
export interface ITestResultsContainerProps {
   
}
const TestResultsContainer = ( props: ITestResultsContainerProps ): JSX.Element => {
    const location = useLocation()
    const {userId, testId} = useParams() 
    const path = component_url("TestsResultsView") + "/" 
    const userResults = useTestsStore((state: ITestsStore) => state.userResults)
    const users: IUser[] = useDataStore((state: any) => state.User || [])
    const test = useTest( testId || 0 )
    const [key, setKey] = useState<string>("users")

    const getUser = () => {
        return userResults[ userId || 1 ]?.user || users.find(user => user.id === userId)
    } 
    return <div className='short-container'>
        <div className="w-100 h-40px mb-4 text-light d-flex align-items-center " style={{backgroundColor: "#181e24"}}>
            <div className='container d-flex align-items-center '> 
                <Link to={ path } >
                    <Button variant="minimal">
                        <span className="descr text-light">
                            <i className="fas fa-chart-line mr-2" />
                            <span>{__("Tests results")}</span>
                        </span>
                    </Button>
                </Link> 
                {
                    [ 
                        {
                            id:"users",
                            title:"Users",
                            icon: "fas fa-users"
                        }, 
                        {
                            id: "all-tests" ,
                            title: "Tests",
                            icon: "fas fa-star"
                        }                        
                    ]
                    .filter( key => location.pathname.indexOf( key.id ) > 0 )
                    .map(key => {
                        // setKey( key )
                        return <Fragment key={ key.id } >
                            <div className="px-1 my-auto opacity_5"><Icon icon="chevron-right" /></div>
                            <Link to={ key.id } >
                                <Button variant="minimal" alignText="left" className="btn-stretch p-0">
                                    <span className="descr text-light">
                                       <i className={`mr-2 ${key.icon}`} /> {__( key.title )}
                                    </span>
                                </Button>
                            </Link>
                        </Fragment>
                    })
                }
                {
                    userId && <>                      
                        <div className="px-1 my-auto opacity_5"><Icon icon="chevron-right" /></div>
                        <Link to={ path + key + "/" + userId } >
                            <Button variant="minimal" alignText="left" className="btn-stretch p-0">
                                <div className="w-100 d-flex align-items-center">
                                    <div className="avatar thumbnail rounded-circle" style={{backgroundImage:`url(${ getUser()?.avatar })`, width: 23, height: 23, minWidth: 23 }} />
                                    <div className="d-flex w-100 px-1 ">
                                        <span className="descr text-light">
                                            { getUser()?.display_name || "User..." }
                                        </span>    
                                    </div>
                                </div>            
                            </Button> 
                        </Link>
                    </>
                }
                {
                    testId && <>                        
                        <div className="px-1 my-auto opacity_5"><Icon icon="chevron-right" /></div>
                        <Link to={ path  +  key + "/" + userId + "/" + testId } >
                            <Button variant="minimal">
                                <span className="descr text-light">
                                    { test?.title || "Test..." }
                                </span> 
                            </Button>
                        </Link>
                    </>
                }                
            </div>
        </div>
        <div className='container px-0 mt-0 mb-5'>
            <Outlet />
        </div>
        
    </div>
}
export default TestResultsContainer
 